import { EMPTY_FIELD_DISPLAY } from '../components/forms/viewOnlyFieldUtils';

/**
 * Summary step row display: numeric `0` and boolean `false` are real values.
 * Only null, undefined, whitespace-only strings, and NaN → em dash (#1325).
 */
export function summaryRowDisplayParts(
  value: string | number | boolean | null | undefined,
): { displayText: string; isSpecified: boolean } {
  if (value === null || value === undefined) {
    return { displayText: EMPTY_FIELD_DISPLAY, isSpecified: false };
  }
  if (typeof value === 'number') {
    if (Number.isNaN(value)) {
      return { displayText: EMPTY_FIELD_DISPLAY, isSpecified: false };
    }
    return { displayText: String(value), isSpecified: true };
  }
  if (typeof value === 'boolean') {
    return { displayText: value ? 'Yes' : 'No', isSpecified: true };
  }
  const s = String(value);
  if (s.trim() === '') {
    return { displayText: EMPTY_FIELD_DISPLAY, isSpecified: false };
  }
  return { displayText: s, isSpecified: true };
}
